var _defs, _g, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359,
    height: 343,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#d0dadf}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(-549 -397.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(549 397.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    style: {
      fill: "#fafafa",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeDasharray: "10 10"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359,
    height: 343,
    rx: 5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 358,
    height: 342,
    rx: 4.5,
    style: {
      fill: "none"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(669.141 539.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(66.535 16.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-2",
    d: "M290.06 108.74a6.227 6.227 0 1 0 6.512 6.221 6.378 6.378 0 0 0-6.512-6.221z",
    transform: "translate(-283.548 -108.74)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(37.933 55.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-2",
    d: "M182.894 286.1c-11.731 0-21.238 9.083-21.238 20.287s9.507 20.288 21.238 20.288 21.239-9.084 21.239-20.288-9.509-20.287-21.239-20.287zm11.963 22.691h-9.23v9.043a2.775 2.775 0 0 1-5.543 0v-9.043h-9.192a2.65 2.65 0 1 1 0-5.3h9.192v-8.551a2.775 2.775 0 0 1 5.543 0v8.56h9.23a2.65 2.65 0 1 1 0 5.3z",
    transform: "translate(-161.656 -286.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-2",
    d: "M113.654 36.892H4.687A4.743 4.743 0 0 0 0 41.493v67.135c0 2.434 2.14 4.169 4.687 4.169h27.7c0-14.122 12.014-25.582 26.781-25.582s26.784 11.46 26.784 25.585h27.7a4.321 4.321 0 0 0 4.609-4.169V41.493a4.674 4.674 0 0 0-4.607-4.601zM91.866 67.3 74.395 84 47.8 58.594a.952.952 0 0 0-1.306 0L29.628 74.707l-7.7-7.355a1 1 0 0 0-1.339 0L8.315 79.044V44.835h101.633v38.5L93.17 67.3a.951.951 0 0 0-1.304 0z",
    transform: "translate(0 -36.892)"
  }))))))), /*#__PURE__*/React.createElement("text", {
    id: "Logo",
    transform: "translate(693.233 513.399)",
    style: {
      fontSize: 24,
      fontFamily: "Poppins-Regular,Poppins",
      fill: "#d0dadf"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Logo")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/defaultLogo.bf695df27f0c2138de30ce1e03503706.svg";
export { ForwardRef as ReactComponent };